import { household } from "propTypes/household.propType";
import propTypes from "prop-types";

export default {
  household: household,
  households: propTypes.arrayOf(household)
};
